export const INTEGRATION_FLOWS = {
  CREATE_TICKET_ON_FINDING: 'create_ticket_on_finding',
  INGEST_EXTERNAL_VULNERABILITIES: 'ingest_external_vulnerabilities',
  SYNC_STATUS_RETEST: 'sync_status_retest',
  SYNC_STATUS_FALSE_POSITIVE: 'sync_status_false_positive',
  SYNC_STATUS_WONTFIX: 'sync_status_wontfix',
  NOTIFY_ON_REMEDIATION_PR: 'notify_on_remediation_pr',
  PUSH_FINDING_TO_SIEM: 'push_finding_to_siem',
  PUSH_FINDING_TO_TORQ: 'push_finding_to_torq',
  STAGE_PREVENTION_ON_FINDING: 'stage_prevention_on_finding',
  SYNC_EXTERNAL_NETWORK_INVENTORY: 'sync_external_network_inventory',
  SYNC_EXTERNAL_NETWORK_DNS: 'sync_external_network_dns',
} as const;

export type IntegrationFlowType =
  (typeof INTEGRATION_FLOWS)[keyof typeof INTEGRATION_FLOWS];

export const ALL_INTEGRATION_FLOWS = Object.values(INTEGRATION_FLOWS);
